<script setup lang="ts">
    import { inject } from 'vue';
    import EventEditorIssueConfirmations, { type IssueConfirmation } from '@views/Event/EventEditor/EventEditorIssueConfirmations.vue';
    import { TestSendStatus } from '@views/Event/EventConfirmationContent.vue';
    import { addDefaultAttestationIssue, deleteAttestationIssue } from '@views/Event/Event.access';
    import { type Event } from '@views/Event/EventTypes';
    import { eventKey } from '@views/Event/EventEditor/event-editor-keys';

    defineProps<{
        eventId: string;
    }>();

    const event = inject(eventKey)!;

    const confirmations: IssueConfirmation[] = [
        {
            title: $Resources.EventAttestationApprovalHeader,
            description: $Resources.EventAttestationApprovalDescription,
            contentTitle: $Resources.EventMessageToAttestHeader,
            subjectKey: 'AttestationSubject',
            textKey: 'AttestationText',
            status: TestSendStatus.Attestation,
        },
        {
            title: $Resources.EventPendingAttestationConfirmation,
            description: $Resources.EventPendingAttestationConfirmationDescription,
            contentTitle: $Resources.EventMessageToPendingAttestationGuests,
            subjectKey: 'AttestationPendingSubject',
            textKey: 'AttestationPendingText',
            status: TestSendStatus.AttestationPending,
        },
        {
            title: $Resources.EventRejectedAttestationConfirmation,
            description: $Resources.EventRejectedAttestationConfirmationDescription,
            contentTitle: $Resources.EventMessageToRejectedAttestationGuests,
            subjectKey: 'AttestationRejectedSubject',
            textKey: 'AttestationRejectedText',
            status: TestSendStatus.AttestationRejected,
        },
    ];
</script>

<template>
    <!-- Nothing is shown unless attestation is required, so the issue isn't loaded either. -->
    <EventEditorIssueConfirmations
        v-if="event?.RequireAttestation"
        :eventId="eventId"
        issueIdKey="AttestationIssueId"
        :confirmations="confirmations"
        newIssueQueryKey="attestationIssue"
        :addDefaultIssue="addDefaultAttestationIssue"
        :deleteIssue="deleteAttestationIssue"
        :heading="$Resources.EventAttestationHeader"
        :description="$Resources.EventAttestationDescription"
        :missingHeading="$Resources.EventMissingAttestationHeading"
        :missingText="$Resources.EventMissingAttestationText"
        :missingStandardBtnText="$Resources.EventMissingAttestationStandardBtnText"
        :missingCustomBtnText="$Resources.EventMissingAttestationCustomBtnText" />
</template>
